import { stats } from '@/mocks/home';

export default function StatsBar() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-primary-500">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-primary-200">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}